module.exports = __webpack_public_path__ + "static/img/toPay.b4d2e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/toPay.png
// module id = 48Je
// module chunks = 21